import React from 'react';
import { HelpModal, NextButton } from 'react-commons';
import { QuestionMark, List, ButtonGrid, Container } from 'react-design-components';
import { FlowEnum, ComponentsEnum } from '../../types';
import { MainLayout } from '../MainLayout';
import usePreResult from './hooks/usePreResult';
import { PreResultHelp } from '../Help';
import { useMediaQuery, useTheme } from '@material-ui/core';

interface Props {
  nextUrl: string;
  progress?: number;
  flow?: FlowEnum;
}

const PreResult: React.FC<Props> = (props: Props) => {
  const { nextUrl, progress, flow } = props;
  const { t, toggleHelpModal, onSubmit, titleComp, listItems, classes } = usePreResult(nextUrl);
  const isVerySmallScreen = useMediaQuery('(max-width:400px)');
  return (
    <MainLayout
      navigationId={ComponentsEnum.PACKAGE}
      flow={flow}
      progress={progress}
      directAccess={false}
      t={t}
      pageTitle="page_title"
    >
      <div className={classes.alignBottom}>
        <Container withButtonGrid>
          <HelpModal>
            <PreResultHelp />
          </HelpModal>
          <QuestionMark onHelpClick={toggleHelpModal} title={titleComp}>
            <List items={listItems} />
          </QuestionMark>

          <ButtonGrid justify="flex-start" noPadding baseMd={12} baseLg={12}>
            <NextButton t={t} translationKey={isVerySmallScreen ? 'continue_short' : 'continue'} onClick={onSubmit} />
          </ButtonGrid>
        </Container>
      </div>
    </MainLayout>
  );
};

export default PreResult;
